import React, { useState, useEffect, useRef } from "react";
import { Chart as ChartJS, registerables } from "chart.js";
import { Line } from "react-chartjs-2";
import "chartjs-adapter-moment";
import CustomTooltip from "../../Common/CustomTooltip";
import zoomPlugin from 'chartjs-plugin-zoom';
import { mapDataToLabels } from "../../../utils/helper";

ChartJS.register(...registerables, zoomPlugin);

const BsrChart = ({
  data: chartDataProps,
  valueProperty = "value",
  labels,
  hoveredIndex,
  graph2Ref,
  onZoom,
  onResetZoom,
  selectedOption
}) => {
  const [
    dataMain,
    dataFBM,
    dataAmazon,
    dataBsr,
    dataBb,
    dataOffers,
    dataRatings,
    dataReviews,
  ] = chartDataProps || [];
  // const bsrChartRef = useRef(null);

  const dataBsr_L = mapDataToLabels(dataBsr, labels, selectedOption, valueProperty);

  const fillMissingValues = (data) => {
    const filledData = [];
    let lastValue = null;

    data.forEach((value) => {
      if (value !== null) {
        lastValue = value;
      }
      filledData.push(lastValue);
    });

    return filledData;
  };

  const filledDataBsr = fillMissingValues(dataBsr_L);

  const min = Math.min(...filledDataBsr);
  const max = Math.max(...filledDataBsr);

  const valueFormatter = (num) => {
    if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + "B";
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
    if (num >= 1_000) return (num / 1_000).toFixed(1) + "k";
    return num.toString();
  };

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: "Sales Rank",
        data: filledDataBsr,
        borderColor: "#4ade80",
        borderWidth: 3,
        stepped: true,
        pointRadius: 0,
      },
    ],
  };

  const chartOptions = {
    isBarChart: true,
    plugins: {
      zoom: {
        zoom: {
          drag: {
            enabled: true,        
            backgroundColor: 'rgba(10,128,255,0.3)', 
          },
          mode: 'x',         
          onZoom: ({ chart }) => {
            if (onZoom) {
              onZoom(chart);
            }
          },
          onZoomComplete: ({ chart }) => {
            if (onZoom) {
              onZoom(chart);
            }
          }
        },
        limits: {
          x: { min: 'original', max: 'original' },
        }
      },
      tooltip: {
        enabled: false,
        mode: "index",
        intersect: false,
        // callbacks: {
        //   label: (context) => {
        //     const label = context.dataset.label || "";
        //     const value = context.raw || 0;
        //     return `${label}: ${valueFormatter(value)}`;
        //   },
        // },
      },
      legend: {
        display: false,
      },
      // corsair: {
      //   horizontal: false,
      //   vertical: false,
      //   color: 'red',
      //   dash: [],
      //   width: 2
      // }
    },
    onClick: (e, elements, chart) => {
      if (e.native.detail === 2) {
        if (onResetZoom) {
          onResetZoom();
        }
      }
    },
    scales: {
      x: {
        ticks: {
          color: "#E5E7EB",
          font: {
            size: 9,
          },
          callback: function (value, index, ticks) {
            const fullLabel = this.getLabelForValue(value);
            const [day, month] = fullLabel.split(" ");
            return `${day} ${month}`;
          },
        },
        grid: {
          color: "rgba(229, 229, 229, 0.3)",
        },
        border: {
          color: "#E5E7EB",
          width: 1,
        },
      },
      y: {
        suggestedMin: min - 5,
        suggestedMax: max + 5,
        ticks: {
          callback: valueFormatter,
          color: "#E5E7EB",
        },
        grid: {
          color: "rgba(229, 229, 229, 0.3)",
        },
        border: {
          color: "#E5E7EB",
          width: 1,
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    // onHover: (event, chartElement) => {
    //   if (chartElement.length) {
    //     const index = chartElement[0].index;
    //     // atHover(index);
    //     hoveredIndex.current = index;
    //   } else {
    //     // onLeave();
    //   }
    // },
  };

  return (
    <React.Fragment>
      <div
        className="bg-secondary-bg flex flex-col border border-primary/100 rounded-lg shadow-sm w-full p-1 relative"
        style={{
          minWidth: "100%",
          minHeight: "150px",
        }}
      >
        <Line
          id="bsrchart"
          data={chartData}
          options={chartOptions}
          ref={(chart) => {
            if (chart) {
              graph2Ref.current = chart;
            }
          }}
          
        />
        <CustomTooltip
          chart={graph2Ref}
          valueFormatter={valueFormatter}
          chart_type={"bsr"}
        />
      </div>

      {/* <button onClick={() => {
        // bsrChartRef.current.setActiveElements([
        //   {
        //     datasetIndex: 0,
        //     index: 5,
        //   }
        // ])
        
        graph2Ref.current.corsair = { x: 200, y: 0, draw: true };
        graph2Ref.current.update();
      }}>button</button> */}
    </React.Fragment>
  );
};

export default BsrChart;
